var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow-down-sign-to-navigate_6_",
    "data-name": "arrow-down-sign-to-navigate (6)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.243,
    height: 4.699,
    viewBox: "0 0 8.243 4.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6066",
    "data-name": "Path 6066",
    d: "M4.122,97.141a.576.576,0,0,0-.408.169L.17,100.854a.577.577,0,0,0,.816.816l3.136-3.136,3.136,3.136a.577.577,0,0,0,.816-.816L4.53,97.309A.576.576,0,0,0,4.122,97.141Z",
    transform: "translate(-0.001 -97.141)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown2);
export default __webpack_public_path__ + "static/media/arrow-down2.08377664d88b849c8d21acd27e399a72.svg";
export { ForwardRef as ReactComponent };